
const digest = '186daa060765176ecf872cc8ace94a18c996387b5e1d866332313eb897c97b8d';
const css = `._resizer_sf0oc_1 {
  position: relative;
  display: inline-block;
  font-size: 0;
  vertical-align: middle;
  /* This is what prevents the content from trying to be bigger than its container (like a table cell or narrow note). */
  max-width: 100%;
}

._resizer_sf0oc_1._resizing_sf0oc_10 {
  background: rgba(31, 28, 28, 0.3);
}

._handle_sf0oc_14 {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 8px;
  height: 8px;
  position: absolute;
  /* Resizer handles appear above table cell handles. */
  z-index: 12;
}

._handle_sf0oc_14._positionw_sf0oc_26:after,
._handle_sf0oc_14._positione_sf0oc_27:after,
._handle_sf0oc_14._positions_sf0oc_28:after {
  content: '';
  background-color: var(--aha-blue-400);
  max-width: 100%;
  max-height: 100%;
  border-radius: 7px;
  border: 1px solid white;
}

._handle_sf0oc_14._positionw_sf0oc_26:after,
._handle_sf0oc_14._positione_sf0oc_27:after {
  height: 70px;
  max-height: 100%;
  width: 7px;
}

._handle_sf0oc_14._positions_sf0oc_28:after {
  width: 70px;
  max-width: 100%;
  height: 7px;
}

._handle_sf0oc_14._positionw_sf0oc_26 {
  height: 100%;
  top: 0;
  width: 10px;
  left: -8px;
  cursor: col-resize;
}

._handle_sf0oc_14._positione_sf0oc_27 {
  height: 100%;
  top: 0;
  width: 10px;
  right: -8px;
  cursor: col-resize;
}

._handle_sf0oc_14._positions_sf0oc_28 {
  width: 100%;
  left: 0;
  height: 10px;
  bottom: -8px;
  cursor: row-resize;
}

._handle_sf0oc_14._positionse_sf0oc_74 {
  bottom: -7px;
  right: -7px;
  width: 10px;
  height: 10px;
  background-color: var(--aha-blue-400);
  border-radius: 10px;
  cursor: nwse-resize;
}

._pixelSize_sf0oc_84 {
  position: absolute;
  bottom: 6px;
  right: 6px;
  background: rgba(43, 124, 199, 0.8);
  color: white;
  font-size: 10px;
  padding: 4px;
  border-radius: 4px;
  line-height: initial;
}

._pixelSize_sf0oc_84 ._width_sf0oc_96:after {
  content: 'x';
  padding: 3px;
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"resizer":"_resizer_sf0oc_1","resizing":"_resizing_sf0oc_10","handle":"_handle_sf0oc_14","positionw":"_positionw_sf0oc_26","positione":"_positione_sf0oc_27","positions":"_positions_sf0oc_28","positionse":"_positionse_sf0oc_74","pixelSize":"_pixelSize_sf0oc_84","width":"_width_sf0oc_96"};
export { css, digest };
  